export default __webpack_public_path__ + "static/media/nftLevel5.4572ff37.jpg";